module.exports = __webpack_public_path__ + "73d1ec0cd920622baf3cfdf6e74253d4.png";